module.exports = __webpack_public_path__ + "img/index-banner-2.6b4e981c.jpg";